/**
 * Respond to client
 *
 * @public
 * @param {Object} options
 */
module.exports = function respond(options = {}) {

  const defaultMessage = 'The request was completed, but nothing was returned'

  function respondHtml(req, res) {

    let response = req.response && req.response.pkg || defaultMessage

    const status = response.status || 200

    res
      .status(status)
      .send(response)

  }

  function respondJson(req, res) {

    let response = req.response || {
      message: defaultMessage
    }

    const status = response.status || 200

    Object.assign(response, {
      hash: process.env.STRUCTURE_HASH,
      requestId: req.headers['x-request-id'],
      sentry: res.sentry
    })

    res
      .status(status)
      .json(response)

  }

  return function respondHandler(req, res, next) {
    const logger = req.logger || console
    if(!logger.debug) {
      logger.debug = console.log.bind(console)
    }

    try {

      if (req.contentType === 'text/html') {
        respondHtml(req, res)
      } else {
        respondJson(req, res)
      }

    } catch(e) {

      logger.error('Dispatcher could not respond')
      next(e)

    }

  }

}
